import { api } from "../../../lib/api";
import { ContactFormData, ContactResponse } from "./contact.types";

class ContactService {
  /**
   * Submit Contact Form
   * @param {ContactFormData} payload
   * @returns {Promise<ContactResponse>}
   */
  async submitForm(payload) {
    try {
      const response = await api.post("contactForm/contact", payload);

      return new ContactResponse(true, response.data.data);
    } catch (error) {
      const message =
        error.response?.data?.data?.error ||
        "Failed to send message. Please try again later.";

      return new ContactResponse(false, { error: message });
    }
  }
}

export const contactService = new ContactService();